<template>
  <v-container fluid id="fcreate">
    <v-row>
      <v-col>
        <div class="text-h3 mb-2" v-text="'Создать модификатор'" />
      </v-col>
    </v-row>
    <v-row>
      <v-form v-model="valid" ref="form">
        <v-container fluid>
          <v-row>
            <!-- Название -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.name"
                outlined
                required
                label="Название"
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Описание -->
            <v-col cols="12" md="7">
              <v-textarea
                v-model="data.description"
                label="Описание"
                outlined
                :rules="rules.description"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Действие -->
            <v-col cols="12" md="7">
              <v-radio-group
                v-model="data.action"
                row
                :rules="rules.requiredRadioButtonGroup"
              >
                <template v-slot:label>
                  <div>Выберите действие модификатора:</div>
                </template>
                <v-radio value="add" label="Добавить" />
                <v-radio value="subtract" label="Вычесть" />
              </v-radio-group>
            </v-col>
            <!-- Тип -->
            <v-col cols="12" md="7">
              <v-radio-group
                v-model="data.type"
                row
                :rules="rules.requiredRadioButtonGroup"
              >
                <template v-slot:label>
                  <div>Выберите тип модификатора:</div>
                </template>
                <v-radio value="single" label="Чекбокс" />
                <v-radio value="select" label="Тумблер" />
              </v-radio-group>
            </v-col>
            <!-- Price Rate -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.priceRate"
                label="Price Rate"
                outlined
                required
                :rules="rules.requiredNumber"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Добавочная цена -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.priceAdd"
                label="Добавочная цена"
                outlined
                required
                :rules="rules.requiredNumber"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Отключ состояние модификатора -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.nameOff"
                label="Надпись отключенного состояния модификатора"
                outlined
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Включ состояние модификатора -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.nameOn"
                label="Надпись включенного состояния модификатора"
                outlined
                required
                :rules="rules.required"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Техническая карта -->
            <v-col cols="12" md="7">
              <v-autocomplete
                v-model="data.technicalCardId"
                :items="getTechnicalCardsList"
                item-text="name"
                item-value="id"
                label="Техническая карта"
                outlined
                required
                :rules="rules.requiredNumber"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Индекс сортировки -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.sortOrder"
                label="Индекс сортировки"
                outlined
                required
                :rules="rules.requiredNumber"
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Submit -->
            <v-col cols="12" md="7">
              <v-btn
                class="mb-2"
                block
                color="primary"
                :loading="loading"
                :disabled="loading"
                @click.prevent="submit"
              >
                Создать
              </v-btn>
              <v-btn
                block
                :loading="loading"
                :disabled="loading"
                @click.prevent="$router.push('/modifications')"
              >
                Отмена
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'

  export default {
    mixins: [rules],
    data () {
      return {
        data: {
          name: '',
          description: '',
          action: 'add',
          type: 'single',
          priceAdd: '',
          priceRate: '',
          nameOn: '',
          nameOff: '',
          technicalCardId: null,
          sortOrder: '1',
          status: true,
        },
        valid: false,
        loading: false,
        snackbar: false,
      }
    },
    computed: {
      ...mapGetters({
        getTechnicalCardsList: 'technicalCards/getTechnicalCardsList',
      }),
    },
    async created () {
      this.loading = true

      await this.$store.dispatch('technicalCards/fetchTechnicalCardsList', {
        limit: 100000,
        offset: 0,
        page: 0,
      })

      this.loading = false
    },
    methods: {
      async submit () {
        const validate = await this.$refs.form.validate()

        if (validate) {
          this.loading = true

          try {
            await this.$store.dispatch('modifications/createModifications', this.data)
            this.loading = false
            this.$router.push('/modifications')
          } catch (e) {
            this.loading = false
            console.log(e)
          }
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }
      },
    },
  }
</script>
